<template>
    <div>
        <GridColumnMenuCheckboxFilter :column="column" :filter="filter" :filterable="filterable" :unique-data="uniqueData"
            :search-box="false" :data-items="filterItems" :expanded="true" @filterchange="filterChange" @expandchange="expandChange"
            @closemenu="closeMenu" />
    </div>
</template>
<script>
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-vue-grid';

export default {
    props: {
        column: Object,
        filter: Object,
        filterable: Boolean,
        uniqueData: {
            type: Boolean,
            default: true
        },
        items: Array
    },
    data() {
        return {
        originalItems:[
                {
                    value:"Pending", adInfoFieldEn: "Under Review",adInfoFieldTc: "審批中",adInfoFieldSc: "审批中",
                },
                {
                    value:"PendingManualAudit", adInfoFieldEn: "Manual Review", adInfoFieldTc: "人工審批中", adInfoFieldSc: "人工审批中",
                },
                {
                    value:"Unsubmitted", adInfoFieldEn: "Unsubmitted",adInfoFieldTc: "未提交", adInfoFieldSc: "未提交",
                }
                /*,{
                    value:"Disabled", adInfoFieldEn: "Disabled",adInfoFieldTc: "已停用", adInfoFieldSc: "已停用",
                 
                }*/
                ,{
                   value:"PendingGoLive", adInfoFieldEn: "Pending go-live",adInfoFieldTc: "待上架",adInfoFieldSc: "待上架",
                }
                ,{
                   value:"Active",  adInfoFieldEn: "Active",adInfoFieldTc: "已上架",adInfoFieldSc: "已上架",
                }
               /*,{
                     value:"Offline", adInfoFieldEn: "Offline",adInfoFieldTc: "已下架",adInfoFieldSc: "已下架",
                }*/
                ,{
                    value:"Rejected", adInfoFieldEn: "Rejected",adInfoFieldTc: "已駁回",adInfoFieldSc: "已驳回",
                },
                {
                    value:"Expired", adInfoFieldEn: "Expired", adInfoFieldTc: "已過期", adInfoFieldSc: "已过期",
                },
                {
                     value:"NoAd", adInfoFieldEn: "Not available",adInfoFieldTc: "無廣告",adInfoFieldSc: "无广告",
                },
            ],
        };
    },
    computed: {
        filterItems() { 
            const currentLang = localStorage.getItem('currentLangId'); 
            const langMap = {
                '936': 'adInfoFieldSc',
                '950': 'adInfoFieldTc',
                '1252': 'adInfoFieldEn'
            };
            
            // 获取当前语言对应的字段名
            const currentField = langMap[currentLang] || 'adInfoFieldSc';
            
            // 转换数据格式
            return this.originalItems.map(item => ({  
                adInfoFieldStatus: item[currentField] // 根据当前语言显示文本
            }));
        }
    },
    components: {
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    methods: {
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            console.log('newDescriptor')
               // 确保传递的是 value 值而不是 displayText 
            let oringalData=newDescriptor;
             if (oringalData && oringalData.filters) {
                // 处理多条件过滤
                const processedDescriptor = {
                    ...oringalData,
                    filters: oringalData.filters.map(filterItem => { 
                        return {
                            ...filterItem,
                            filters:filterItem.filters.map(subFilter=>{
                               return{
                                ...subFilter,
                                value:this.getOriginalValueFromText(subFilter.value),
                                 operator: 'contains',
                               } 
                            }) 
                        };
                    })
                };
        //if(newDescriptor.filters.length>0){
          
        //}
            this.$emit('filterchange', processedDescriptor, e);
            this.$emit('setAdInfoFilter', newDescriptor); 
            } else {
            //if(newDescriptor.filters.length>0){ 
            //}
            this.$emit('filterchange', newDescriptor, e);
            this.$emit('setAdInfoFilter', newDescriptor); 
            } 
        },
            getOriginalValueFromText(displayText) {
         if (!displayText) return '';

         const currentLang = localStorage.getItem('currentLangId');  
         let itemOrigina =null;
         if(currentLang=='936')
         {
            itemOrigina=this.originalItems.find(a=>a.adInfoFieldSc==displayText);
         }else if(currentLang=='950'){
            itemOrigina=this.originalItems.find(a=>a.adInfoFieldTc==displayText);
         }else {
             itemOrigina=this.originalItems.find(a=>a.adInfoFieldEn==displayText);
         }
         if (!itemOrigina) {
            itemOrigina = this.originalItems.find(a => a.value === displayText);
         }
         return itemOrigina ? itemOrigina.value : displayText;
        },
    }
}
</script>